import { render, staticRenderFns } from "./tiple.vue?vue&type=template&id=a16a9ab2&scoped=true&"
import script from "./tiple.vue?vue&type=script&lang=js&"
export * from "./tiple.vue?vue&type=script&lang=js&"
import style0 from "./tiple.vue?vue&type=style&index=0&id=a16a9ab2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a16a9ab2",
  null
  
)

export default component.exports